import { linkSystemProductsTranslations } from "./index";

export const LINK_SYSTEM_PRODUCTS_ES_MX: linkSystemProductsTranslations = {
	title: "Importar producto",
	subtitle: "Vincula los productos importados con los datos de productos de Zig",
	helpText:
		"Ahora puedes vincular los elementos importados a los productos que ya tenemos en la plataforma, con todo rellenado.",
	noCategory: "Sin categoría",
	table: {
		systemProduct: "Vínculo de productos Zig",
	},
	validation: {
		unlinkedCount: {
			one:
				"1 producto no ha sido vinculado. Por favor, vincule el producto antes de continuar.",
			other:
				"{count} productos no han sido vinculados. Por favor, vincule todos los productos antes de continuar.",
		},
	},
};
